import { CSSProperties } from 'react';

export const BASE_CLASSNAME = 'w-8 h-8 min-w-8 min-h-8';

export const FULL_CLASSNAME = `${BASE_CLASSNAME} bg-purple-500`;

export const EMPTY_CLASSNAME = `${BASE_CLASSNAME} bg-neutral-300`;

export const BASE_STYLE: CSSProperties = {
  width: '30px',
  height: '30x',
  minWidth: '30px',
  minHeight: '30px',
  display: 'flex',
};

export const BASE_STYLE_MOBILE: CSSProperties = {
  width: '28px',
  height: '28x',
  minWidth: '28px',
  minHeight: '28px',
  display: 'flex',
};
